import core from '@gin-betting/core';

import type { SearchObj } from 'types';

const {
    services: { stringify: coreStringify },
} = core;

const stringify: (obj: SearchObj) => string = coreStringify;

export default stringify;
